/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ConnectionOccasionType } from './connectionOccasionType';

/**
 * Occasion metadata returned on connection payloads.
 */
export interface ConnectionOccasion {
  type: ConnectionOccasionType;
  slotId: string;
}
